import { useCallback } from 'react';
import { useMutateEntry } from '@utils/component-framework';

const useUpdateIGuideEntryInputMutation = entryKey => {
  const updateComponentEntry = useMutateEntry(entryKey);
  return useCallback((taskId, inputId, value) => {
    updateComponentEntry(entry => {
      entry.data.answers[taskId] ??= {};
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      entry.data.answers[taskId][inputId] = value;
      return entry;
    });
  }, [updateComponentEntry]);
};

export { useUpdateIGuideEntryInputMutation };
//# sourceMappingURL=mutation.update-entry-value.js.map
